import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const PasswordReset = ({ mode }) => {
  const forgot = mode === "forgot";
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault(); setError(""); setMessage("");
    if (!forgot && password !== confirmation) { setError("Le password non coincidono"); return; }
    setLoading(true);
    try {
      if (forgot) {
        const { data } = await api.post("/auth/forgot-password", { email });
        setMessage(data.message);
      } else {
        const token = params.get("token");
        if (!token) throw new Error("Link di recupero non valido");
        const { data } = await api.post("/auth/reset-password", { token, password });
        setMessage(data.message);
        setTimeout(() => navigate("/login"), 1800);
      }
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return <div className="mx-auto flex min-h-[65vh] max-w-lg items-center px-6 py-16"><section className="w-full border bg-white p-7 md:p-10"><p className="text-[10px] uppercase tracking-[.25em] text-champagne">KAÓS®</p><h1 className="mt-3 font-serif text-3xl">{forgot ? "Recupera la password" : "Crea una nuova password"}</h1><p className="mt-3 text-sm leading-6 text-stone-500">{forgot ? "Inserisci l’email del tuo account. Riceverai un collegamento valido per un’ora." : "Scegli una nuova password di almeno 8 caratteri."}</p><form onSubmit={submit} className="mt-7 space-y-5">{forgot ? <label className="block text-[10px] uppercase tracking-wider">Email<Input required type="email" value={email} onChange={e=>setEmail(e.target.value)} className="mt-2 rounded-none"/></label> : <><label className="block text-[10px] uppercase tracking-wider">Nuova password<Input required minLength={8} type="password" value={password} onChange={e=>setPassword(e.target.value)} className="mt-2 rounded-none"/></label><label className="block text-[10px] uppercase tracking-wider">Ripeti la password<Input required minLength={8} type="password" value={confirmation} onChange={e=>setConfirmation(e.target.value)} className="mt-2 rounded-none"/></label></>}{error&&<p className="text-sm text-red-700">{error}</p>}{message&&<p className="border border-green-200 bg-green-50 p-3 text-sm text-green-800">{message}</p>}<Button disabled={loading||Boolean(message)} className="h-12 w-full rounded-none bg-charcoal text-xs uppercase tracking-[.18em] text-white">{loading?"Attendi…":forgot?"Invia il link":"Aggiorna password"}</Button></form><Link to="/login" className="mt-6 block text-center text-xs text-stone-500 underline">Torna all’accesso</Link></section></div>;
};

export default PasswordReset;
